import { IncidentNature } from '@app/shared/enums/incident-nature.enum';
import { PerformanceCategoryScoreApiModel } from './PerformanceCategoryScoreApiModel';

export class IncidentSummaryApiModel {
  public Date: Date;
  public FormInstanceId: number;
  public FormInstanceName: string;
  public FormInstanceNumber: string;
  public IncidentTypeName: string;
  public Nature: IncidentNature;
  public CompletedBy: string;
  public CurrentStepName: string;
  public PerformanceCategories: PerformanceCategoryScoreApiModel[];

  public fullName: string;
  public score: string;

  public deserialize(data: Object): IncidentSummaryApiModel {
    Object.assign(this, data);

    this.Date = new Date(this.Date);
    this.fullName = this.FormInstanceNumber
      ? `${this.FormInstanceName}#${this.FormInstanceNumber}`
      : this.FormInstanceName;

    return this;
  }
}
